<meta http-equiv="Cache-Control" content=" max-age=1500, must-revalidate"/>
<template>
<div>
  <div style = "display: none">
    <img class="centerImage" rel="prefetch" :src="getTrialCues['cue1']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialCues['cue2']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialCues['cue3']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialCues['cue4']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialCues['cue5']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialCues['cue6']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialCues['cue7']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialCues['cue8']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe1']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe2']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe3']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe4']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe5']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe6']"/>
    <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe7']"/>
  </div>
</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import State from '../mixins/State'
export default {
  mixins: [ State ],
  data: () => {
    return {
      timer: undefined,
      start_time: undefined,
      end_time: undefined
    }
  },
  computed: {
    ...mapGetters(['getCorrectAudio', 'getIncorrectAudio', 'getNoResponseAudio','getTrialCues','getTrialProbes']),
    ...mapState({
      training_finished: state => state.training_finished
    })
  },
  mounted () {
    console.log(this.training_finished)
    if (this.training_finished < 10) {
      this.$router.replace("/training_cue")
    }
    else {
      this.$router.replace('/instructions/5')
      // this.$router.replace('/blank_page/trial')
    }
  }

}
</script>

<style scoped>
  .container {
    height: 50vh;
    width: 50vh;
  }
  .success {
    color: green;
  }
  .failure {
    color: red;
  }
</style>